var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce_editor"},[_c('Editor',{attrs:{"id":"tinymce","initial-value":_vm.content,"init":_vm.editorInit},on:{"onKeyUp":_vm.keyUp,"onChange":_vm.keyUp}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2648e5c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/Editor.vue
// module id = null
// module chunks = 